<div class="assignment-history-item">
  <div class="history-data-row assigned-to" (click)="toggleCollapsed()" [ngClass]="{'collapsible': collapsible}">
    <svg-icon [icon]="collapsed ? 'arrow-right' : 'arrow-down'" class="collapse-icon" *ngIf="collapsible"></svg-icon>
    <span class="history-key">{{ 'assignmentHistoryItem.assignedTo' | translate }}</span>
    <span class="history-value" [title]="assignmentHistoryModel.assignedTo">
      {{assignmentHistoryModel.assignedTo}}
    </span>
  </div>
  <ng-container *ngIf="!collapsed">
    <div class="history-data-row">
      <span class="history-key">{{ 'assignmentHistoryItem.assignedBy' | translate }}</span>
      <span class="history-value" [title]="assignmentHistoryModel.assignedBy || '-'">
        {{assignmentHistoryModel.assignedBy || '-' }}
      </span>
    </div>
    <div class="history-data-row">
      <span class="history-key">{{ 'assignmentHistoryItem.department' | translate }}</span>
      <span class="history-value"
            [title]="assignmentHistoryModel.department || '-'"
            [attr.data-automation-id]="'bc-history-department-value'">
        {{assignmentHistoryModel.department || '-' }}
      </span>
    </div>
    <div class="history-data-row">
      <span class="history-key" [title]="'assignmentHistoryItem.assignedAt' | translate">{{ 'assignmentHistoryItem.assignedAt' | translate }}</span>
      <span class="history-value" [title]="getFormattedDate(assignmentHistoryModel.assignedAt)">
        {{getFormattedDate(assignmentHistoryModel.assignedAt)}}
      </span>
    </div>
    <div class="history-data-row">
      <span class="history-key" [title]="'assignmentHistoryItem.acceptedAt' | translate">{{ 'assignmentHistoryItem.acceptedAt' | translate }}</span>
      <span class="history-value" [title]="getFormattedDate(assignmentHistoryModel.acceptedAt)">
        {{getFormattedDate(assignmentHistoryModel.acceptedAt)}}
      </span>
    </div>
    <div class="history-data-row">
      <span class="history-key" [title]="'assignmentHistoryItem.reassignedOrEnded' | translate">{{ 'assignmentHistoryItem.reassignedOrEnded' | translate }}</span>
      <span class="history-value" [title]="getFormattedDate(assignmentHistoryModel.ended)">
        {{getFormattedDate(assignmentHistoryModel.ended)}}
      </span>
    </div>
    <ng-container *ngIf="isReassigned()">
      <div class="history-data-row">
        <span class="history-key">{{ 'assignmentHistoryItem.reassignedTo' | translate }}</span>
        <span class="history-value" [title]="assignmentHistoryModel.reassignedTo">
        {{assignmentHistoryModel.reassignedTo}}
      </span>
      </div>
      <div class="history-data-row">
        <span class="history-key">{{ 'assignmentHistoryItem.reassignedBy' | translate }}</span>
        <span class="history-value" [title]="assignmentHistoryModel.reassignedBy">
        {{assignmentHistoryModel.reassignedBy}}
      </span>
      </div>
    </ng-container>
  </ng-container>
</div>
